import React from 'react'
import { Chip } from '@arnsbogroup/react-voicearchive'

export default ({ order }) => (
  <>
    { !!order.test && <Chip state="warning">Test</Chip> }
    { !!order.archived && <Chip state="warning">Archived</Chip> }
    { !!order.hidden && <Chip>Hidden</Chip> }
    { !!order.deleted && <Chip state="error">Deleted</Chip> }
    { !!order.standby && <Chip state="info">Standby</Chip> }
    { !!order.closed && <Chip state="error">Closed</Chip> }
    { !!order.invoiced && <Chip state="success">Invoiced</Chip> }
    { !order.test
        && !order.archived
        && !order.hidden
        && !order.deleted
        && !order.standby
        && !order.closed
        && !order.invoiced && (
          <Chip>In Progress</Chip>
        )
    }
  </>
)
